import React from 'react';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ViewClinicHistory from './ViewHistoryComplete';

const ModalHistory = ({ data, openModal, setOpenModal }) => {

    //console.log(data);

    return (
        <Modal
            open={openModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000, }}            
        >
            <div className="paperAppointment-flex" style={{ width: '120%', margin: 10,  }}>
                <IconButton style={{ float: 'right' }} onClick={() => {
                    setOpenModal(false);
                }}>
                    <CloseIcon />
                </IconButton>
                <ViewClinicHistory data={data}/>
            </div>
        </Modal>
    );

}

export default ModalHistory;